import { z } from 'zod/v3';


export const LocalFileIntegrationMetadataSchema = z.object({
  path: z.string(),
  docType: z.string(),
  baseUrl: z.string(),
  isConfigured: z.boolean(),
});
export type LocalFileIntegrationMetadata = z.infer<typeof LocalFileIntegrationMetadataSchema>;

export const ExternalDocsIntegrationMetadataSchema = z.object({
  repository: z.string(),
  branch: z.string(),
  docType: z.string(),
  docsPath: z.string(),
  baseUrl: z.string(),
});
export type ExternalDocsIntegrationMetadata = z.infer<typeof ExternalDocsIntegrationMetadataSchema>;

export const GitHubMetadataInputSchema = z.object({
  workspaceId: z.string(),
  repository: z.string(),
  path: z.string().optional(),
  features: z.object({
    code: z.boolean().default(true),
    issues: z.boolean().default(true),
    pullRequests: z.boolean().default(true),
  }).optional(),
})
export type GitHubMetadataInput = z.infer<typeof GitHubMetadataInputSchema>;